import {handleActions} from 'redux-actions';

import {SIGN_OUT} from '/redux/action/auth.action';
import {
  FETCH,
  FETCH_RECORD,
  RESET,
  RESET_REPORT,
  RESET_REPORT_META,
  SET_STATE,
} from '/redux/action/report.action';
import {withPayload} from '/util/reducer.util';

import authSignOut from './report/auth/signOut';
import fetch from './report/fetch';
import fetchRecord from './report/fetchRecord';
import reset from './report/reset';
import resetReport from './report/resetReport';
import resetReportMeta from './report/resetReportMeta';
import setState from './report/setState';

const initialState = {
  allReportState: {},
  allReportData: {},
  allReportMeta: {},
  allReportRecordData: {},
};

export default handleActions(
  {
    [SET_STATE]: withPayload(setState),
    [FETCH]: withPayload(fetch),
    [FETCH_RECORD]: withPayload(fetchRecord),
    [SIGN_OUT]: withPayload(authSignOut),
    [RESET]: withPayload(reset),
    [RESET_REPORT]: withPayload(resetReport),
    [RESET_REPORT_META]: withPayload(resetReportMeta),
  },
  initialState,
);
